export const createCornerGuidelines = (component: any) => {
  if (component) {
    const elementBounds = component.getBoundingClientRect();

    const verticalGuideLine = document.createElement("div");
    verticalGuideLine.classList.add("component-base-vertical-guide-line");
    verticalGuideLine.style.height = elementBounds.top + "px";
    verticalGuideLine.style.left = elementBounds.left + "px";
    document.body.appendChild(verticalGuideLine);

    const horizontalGuideLine = document.createElement("div");
    horizontalGuideLine.classList.add("component-base-horizontal-guide-line");
    horizontalGuideLine.style.width = elementBounds.left + "px";
    horizontalGuideLine.style.top = elementBounds.top + "px";
    document.body.appendChild(horizontalGuideLine);

    return {
      horizontalGuideLine,
      verticalGuideLine,
    };
  }

  return {
    horizontalGuideLine: null,
    verticalGuideLine: null,
  };
};

// COMPONENT SNAPPING: create object with all component coords and check against zones and snap if within reach?
// show lines if center of another component or center of screen, snap to center, top, bottom, left, right?

export const createCornerGuidelineInfo = (component: any) => {
  if (component) {
    const elementBounds = component.getBoundingClientRect();

    const verticalGuideLineInfo = document.createElement("div");
    verticalGuideLineInfo.classList.add("component-base-guide-line-info");
    verticalGuideLineInfo.style.left = elementBounds.left + "px";
    verticalGuideLineInfo.style.top = elementBounds.top / 2 - 10 + "px";
    verticalGuideLineInfo.textContent = "y: " + elementBounds.top + "px";
    document.body.appendChild(verticalGuideLineInfo);

    const horizontalGuideLineInfo = document.createElement("div");
    horizontalGuideLineInfo.classList.add("component-base-guide-line-info");
    horizontalGuideLineInfo.style.top = elementBounds.top + "px";
    horizontalGuideLineInfo.style.left = elementBounds.left / 2 - 50 + "px";
    horizontalGuideLineInfo.textContent = "x: " + elementBounds.left + "px";
    document.body.appendChild(horizontalGuideLineInfo);

    return {
      horizontalGuideLineInfo,
      verticalGuideLineInfo,
    };
  }

  return {
    horizontalGuideLineInfo: null,
    verticalGuideLineInfo: null,
  };
};

export const updateGuideLines = (
  component: HTMLElement,
  verticalGuideLine: HTMLElement,
  horizontalGuideLine: HTMLElement
) => {
  const elementBounds = component.getBoundingClientRect();

  verticalGuideLine.style.height = elementBounds.top + "px";
  verticalGuideLine.style.left = elementBounds.left + "px";

  horizontalGuideLine.style.width = elementBounds.left + "px";
  horizontalGuideLine.style.top = elementBounds.top + "px";
};

export const updateGuideLinesInfo = (
  component: HTMLElement,
  verticalGuideLineInfo: HTMLElement,
  horizontalGuideLineInfo: HTMLElement
) => {
  const elementBounds = component.getBoundingClientRect();

  //  update text content
  verticalGuideLineInfo.textContent = "y: " + elementBounds.top + "px";
  horizontalGuideLineInfo.textContent = "x: " + elementBounds.left + "px";

  // prevent two info boxes from overlapping
  if (elementBounds.top < 20 && elementBounds.left < 50) {
    verticalGuideLineInfo.style.top = "0px";
    verticalGuideLineInfo.style.left = "0px";
    horizontalGuideLineInfo.style.top = "20px";
    horizontalGuideLineInfo.style.left = "0px";
  } else {
    // prevent info boxes from being pushed off screen
    if (elementBounds.top > 20) {
      verticalGuideLineInfo.style.top = elementBounds.top / 2 - 10 + "px";
    }

    if (elementBounds.left > 0) {
      verticalGuideLineInfo.style.left = elementBounds.left + "px";
    }

    if (elementBounds.left > 50) {
      horizontalGuideLineInfo.style.left = elementBounds.left / 2 - 25 + "px";
    }

    if (elementBounds.top > 0) {
      horizontalGuideLineInfo.style.top = elementBounds.top + "px";
    }
  }
};

export const removeGuideLines = (
  horizontalGuideLine: HTMLElement | null,
  verticalGuideLine: HTMLElement | null,
  horizontalGuideLineInfo: HTMLElement | null,
  verticalGuideLineInfo: HTMLElement | null
) => {
  if (horizontalGuideLine && document.body.contains(horizontalGuideLine)) {
    document.body.removeChild(horizontalGuideLine);
  }
  if (verticalGuideLine && document.body.contains(verticalGuideLine)) {
    document.body.removeChild(verticalGuideLine);
  }
  if (
    horizontalGuideLineInfo &&
    document.body.contains(horizontalGuideLineInfo)
  ) {
    document.body.removeChild(horizontalGuideLineInfo);
  }
  if (verticalGuideLineInfo && document.body.contains(verticalGuideLineInfo)) {
    document.body.removeChild(verticalGuideLineInfo);
  }
};
